import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaFilePdf } from 'react-icons/fa';
import CopilotStyles from './styles/CalybCopliotStyles';
const FilePreview = ({ fileData, onClose, isCurrent, messages, showCloseButton = true }) => {
    if (!fileData)
        return null;
    if (fileData.size === 0)
        return null;
    console.log('FilePreview render:', { isCurrent, fileData });
    const handleClose = () => {
        // Only allow closing if this is the current message
        if (isCurrent) {
            onClose();
        }
    };
    return (_jsxs("div", { style: CopilotStyles.filePreview, children: [_jsx(FaFilePdf, { style: { fontSize: '24px', color: 'red' } }), _jsxs("div", { style: CopilotStyles.filePreviewName, children: [fileData.name, " (", Math.round(fileData.size / 1024), " KB)"] }), isCurrent && showCloseButton && (_jsx("button", { onClick: handleClose, style: CopilotStyles.filePreviewCloseButton, "aria-label": "Remove file", children: "\u2715" }))] }));
};
export default FilePreview;
